<script>
import ModalsTemplate from "../ModalsTemplate.vue";

import { mapActions } from "vuex";

export default {
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },

  components: {
    ModalsTemplate,
  },

  data: () => ({
    object: {
      id: null,
      code: null,
      name: null,
      questionLimit: 20,
      active: true,
    },

    model: true,
  }),

  watch: {
    model() {
      setTimeout(() => {
        this.$emit("close");
      }, 100);
    },
  },

  created() {
    if (this.data.id) {
      this.object = JSON.parse(JSON.stringify(this.data));
    }
  },

  methods: {
    ...mapActions("admin-sciences", ["ADD_SCIENCE"]),

    onSend() {
      if (this.$refs.form.validate()) {
        this.ADD_SCIENCE(this.object).then((status) => {
          if (status != null) {
            this.$emit("refresh");
            this.model = false;
          }
        });
      }
    },
  },
};
</script>

<template>
  <modals-template :title="$t('Sciences')" :width="650" v-model="model">
    <v-form @submit.prevent="() => false" ref="form" lazy-validation>
      <v-row>
        <v-col cols="12">
          <v-text-field
            autofocus
            autocomplete="off"
            v-model="object.code"
            :label="$t('Code')"
            :rules="[$rules.required]"
            required
            outlined
            hide-details
            v-inputmask="$masks.number"
          />
        </v-col>

        <v-col cols="12">
          <v-text-field
            autocomplete="off"
            v-model="object.name"
            :label="$t('Name')"
            :rules="[$rules.required]"
            required
            outlined
          />
        </v-col>

        <v-col cols="12">
          <v-text-field
            autocomplete="off"
            v-model.number="object.questionLimit"
            :label="$t('Question limit')"
            :hint="$t('Number of questions picked for exam from this subject')"
            :rules="[$rules.required, v => (v && v >= 1) || $t('Minimum 1')]"
            persistent-hint
            outlined
            type="number"
            min="1"
          />
        </v-col>
      </v-row>
    </v-form>

    <template slot="actions">
      <div class="d-flex w-100">
        <v-spacer />
        <v-btn color="primary" class="btn-accent" @click="onSend">
          {{ $t("Save") }}
        </v-btn>
      </div>
    </template>
  </modals-template>
</template>
